<template>
  <div class="antd-slider-custom flex items-center gap-2">
    <div class="w-full">
      <Slider
        :min="min"
        :max="max"
        @change="change"
        :value="value"
      />
    </div>
    <div class="w-24 h-full">
      <Input
        :prefix="prefix"
        :suffix="suffix"
        :value="value"
        @change="onChange"
      />
    </div>
  </div>
</template>

<script>
import {
  Slider, Input,
} from 'ant-design-vue'

export default {
  components: {
    Slider,
    Input,
  },
  props: {
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 100,
    },
    value: {
      type: Number,
      default: 0,
    },
    change: {
      type: Function,
      default: () => {},
    },
    prefix: {
      type: String,
      default: null,
    },
    suffix: {
      type: String,
      default: null,
    },
  },
  methods: {
    onChange(e) {
      this.change(Number(e.target.value))
    },
  },
}
</script>

<style scoped lang="scss">
.btn-underline {
  ::v-deep {
    span {
      text-decoration: underline;
    }
  }
}
.btn-text-default {
  ::v-deep {
    span, i {
      color: #191F2D;
    }
  }
}
.antd-slider-custom {
  ::v-deep {
    .ant-slider {
      .ant-slider-track {
        background-color: #348EF6;
      }
      .ant-slider-handle {
        border-color: #348EF6;
      }
      &:hover {
        .ant-slider-track {
          background-color: #4F9BF3;
        }
        .ant-slider-handle {
          border-color: #4F9BF3;
        }
      }
    }
    .ant-input {
      border-radius: 8px;
      height: 100%;
    }
    .ant-input-affix-wrapper {
      height: 100%;
    }
  }
}
</style>
